
export const SET_FORMULES = "[TARIF] SET FORMULES";

export const setFormules = (payload) => {
  return {
    type: SET_FORMULES,
    payload: payload,
  };
};
